<template>
  <div v-if="visible" class="form-group check-group">
    <label v-once for="display-kwic-header-check">
      {{$t('result.display.kwic_with_header.check')}}
    </label>
    <input v-model="displayHeader" id="display-kwic-header-check" type="checkbox"/>
  </div>
</template>
<script>
  import {mapState} from 'vuex'

  export default {
    computed: {
      ...mapState({
        visible: s => s.api.resultType === 'kwic',
        resultDisplay: s => s.api.resultDisplay
      }),
      displayHeader: {
        get() {
          return this.resultDisplay === 'kwic_with_header'
        },
        set(v) {
          this.$store.commit('api/setResultDisplay', v ? 'kwic_with_header' : 'kwic')
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .check-group {
    display: flex;
    justify-content: space-between;
    label { flex-basis: 100% }
  }
</style>